import React, {FC, PropsWithChildren, useState} from 'react';
import {Dictionary} from '../../../../EOYWizard/types';
import {WidthContext} from './WidthContext';
import {updateColsWidthDictionaryInServer} from '../../../services/serverDataStore';
import {MIN_COLUMN_WIDTH, MAX_COLUMN_WIDTH} from '../../../constants';

interface WidthControllerProps {
    widthDictionary?: Dictionary<number>;
    storeKey?: string;
}

export const WidthController: FC<PropsWithChildren<WidthControllerProps>> = ({
    children,
    widthDictionary,
    storeKey
}) => {
    const [width, setFullWidth] = useState<Dictionary<number>>(widthDictionary || {});

    const setWidth = (id: string, value: number) => {
        let newColWidth = value;
        if (newColWidth < MIN_COLUMN_WIDTH) {
            newColWidth = MIN_COLUMN_WIDTH;
        } else if (newColWidth > MAX_COLUMN_WIDTH) {
            newColWidth = MAX_COLUMN_WIDTH;
        }

        const updatedDictionary = {
            ...width,
            [id]: newColWidth
        };
        setFullWidth(updatedDictionary);
        storeKey && updateColsWidthDictionaryInServer(storeKey, updatedDictionary);
    };

    return (
        <WidthContext.Provider
            value={{
                width,
                setFullWidth,
                setWidth
            }}
        >
            <>{children}</>
        </WidthContext.Provider>
    );
};
